import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carolina Fernández',
    city: 'Buenos Aires',
    age: 34,
    text: 'Desde que tengo el Megapack, mi trabajo cambió completamente. Ya no me llevo nada a casa y mis informes son mucho más profesionales. Lo recomiendo a todas mis colegas.',
    role: 'Acompañante Pedagógica'
  }, {
    name: 'Valeria Rodríguez',
    city: 'Córdoba',
    age: 41,
    text: 'Las plantillas me salvaron la vida. Antes pasaba horas haciendo registros, ahora tengo todo organizado y listo. Una inversión que se paga sola.',
    role: 'Maestra Integradora'
  }, {
    name: 'Luciana Martínez',
    city: 'Rosario',
    age: 29,
    text: 'Recién empiezo en esto y el Megapack me dio toda la estructura que necesitaba. Los modelos de adaptaciones curriculares son oro puro.',
    role: 'APND'
  }, {
    name: 'Andrea González',
    city: 'Mendoza',
    age: 38,
    text: 'Lo mejor es que todo está en un solo lugar. Los bonos sobre TEA y TDAH son súper útiles. Me siento mucho más segura en mi trabajo.',
    role: 'Acompañante Pedagógica'
  }, {
    name: 'Silvina López',
    city: 'La Plata',
    age: 45,
    text: 'Llevo 15 años en esto y nunca había visto algo tan completo. Las estrategias de intervención son prácticas y realmente funcionan en el aula.',
    role: 'Maestra Integradora'
  }];
  return <section className="w-full bg-gray-50 py-16 px-4" data-id="element-195">
      <div className="max-w-5xl mx-auto" data-id="element-196">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-197">
          Lo que dicen quienes ya lo tienen
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-198">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-199">
              <div className="flex items-center gap-1 mb-3" data-id="element-200">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-201" />)}
              </div>
              <p className="text-gray-700 mb-4 italic" data-id="element-202">"{testimonial.text}"</p>
              <div className="border-t border-gray-200 pt-3" data-id="element-203">
                <p className="font-semibold text-gray-900" data-id="element-204">
                  {testimonial.name}
                </p>
                <p className="text-sm text-gray-600" data-id="element-205">{testimonial.role}</p>
                <p className="text-sm text-gray-500" data-id="element-206">
                  {testimonial.city} • {testimonial.age} años
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}